/** Shared billing / card-selection helpers for the subscription wizard. */

export const isNonEmptyString = (value) =>
  typeof value === "string" && value.trim().length > 0;

export const getCardId = (card) => {
  const id = card?.id ?? card?.payment_method_id;
  if (id == null || id === "") {
    return null;
  }
  return String(id);
};

/** Normalize API card payloads to a filtered array with valid IDs. */
export const normalizeCardList = (data) => {
  const raw = data?.cards ?? data?.data ?? [];
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw.filter((card) => getCardId(card));
};

export const isCardInList = (cardId, cards) => {
  if (!isNonEmptyString(cardId == null ? "" : String(cardId))) {
    return false;
  }
  const normalizedId = String(cardId);
  return (Array.isArray(cards) ? cards : []).some(
    (card) => getCardId(card) === normalizedId,
  );
};

export const hasValidCardSelection = (selectedCardId, selectedCard, cards = null) => {
  const id = isNonEmptyString(String(selectedCardId ?? ""))
    ? String(selectedCardId).trim()
    : getCardId(selectedCard);

  if (!id || !selectedCard) {
    return false;
  }

  const cardObjectId = getCardId(selectedCard);
  if (cardObjectId && cardObjectId !== id) {
    return false;
  }

  if (Array.isArray(cards)) {
    return isCardInList(id, cards);
  }

  return true;
};

export const isUnprovisionedCardsResponse = (data) => {
  if (!data || data.success) {
    return false;
  }
  const errorText =
    typeof data.error === "string"
      ? data.error
      : data?.error?.message ?? data?.message ?? "";
  return (
    errorText === "Customer not found" ||
    (Array.isArray(data.cards) && data.cards.length === 0)
  );
};

export const formatCardBrand = (brand) => {
  if (!isNonEmptyString(brand)) {
    return "Card";
  }
  return brand.charAt(0).toUpperCase() + brand.slice(1);
};

export const formatCardExpiry = (card) => {
  const month = card?.exp_month ?? card?.expiry_month;
  const year = card?.exp_year ?? card?.expiry_year;
  const monthText = month != null && month !== "" ? String(month) : "—";
  const yearText =
    year != null && year !== ""
      ? String(year).slice(-2)
      : "—";
  return `${monthText}/${yearText}`;
};
